import React, { useState } from 'react';
import PropsTypes from 'prop-types';
import classNames from 'classnames';
import css from './CreativePreview.css';
import UnavailableCreative from './UnavailableCreative';
import PlayableIndication, { IndicationType } from './PlayableIndication';
import { CreativeTypeValue } from '../../utils/consts';

const INVALID_CREATIVE_IMAGE = 'N/A';
const THUMBNAIL_SUFFIX = '.thumb';
const UNAVAILABLE_HOVER_TEXT = 'STATIC.CREATIVES.NO_GRAPHIC_AVAILABLE_TOOLTIP';
const ERROR_TEXT = 'STATIC.CREATIVES.UNABLE_TO_LOAD_PREVIEW';

const CreativePreview = ({ url, type, className }) => {
    const [hasImageError, setHasImageError] = useState(false);
    const isClickable = url && url !== INVALID_CREATIVE_IMAGE && !hasImageError;

    const handleClick = () => {
        if (isClickable) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    const handleImageError = () => {
        setHasImageError(true);
    };

    const content = (
        <div className={classNames(css.container, className, { [css.clickable]: isClickable })} onClick={handleClick}>
            {!url || url === INVALID_CREATIVE_IMAGE || hasImageError ? (
                <UnavailableCreative hoverText={hasImageError ? ERROR_TEXT : UNAVAILABLE_HOVER_TEXT} type={type} />
            ) : type === CreativeTypeValue.playable ? (
                <PlayableIndication showTooltip showText={false} type={IndicationType.CLICK} />
            ) : (
                <img
                    alt={url}
                    src={`${url}${!url.includes(THUMBNAIL_SUFFIX) ? THUMBNAIL_SUFFIX : ''}`}
                    className={css.asset}
                    onError={handleImageError}
                />
            )}
        </div>
    );

    return content;
};

CreativePreview.propTypes = {
    url: PropsTypes.string,
    type: PropsTypes.oneOf(Object.values(CreativeTypeValue)),
    className: PropsTypes.string,
};
export default CreativePreview;
